import React from 'react';
import { Link } from 'react-router-dom';

interface HashtagTextProps {
  content: string;
  className?: string;
}

// Combined component that handles both mentions and hashtags
const HashtagText: React.FC<HashtagTextProps> = ({ content, className = '' }) => {
  if (!content) return null;

  // Split content by both mentions and hashtags
  // Pattern matches @username and #hashtag
  const combinedRegex = /(@[a-zA-Z0-9_]+|#[a-zA-Z0-9_]+)/g;
  const parts = content.split(combinedRegex);

  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (part.startsWith('#')) {
          const tag = part.slice(1).toLowerCase();
          return (
            <Link
              key={index}
              to={`/athlete-dashboard/wall/tag/${tag}`}
              className="text-primary hover:underline font-medium"
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </Link>
          );
        }
        if (part.startsWith('@')) {
          const username = part.slice(1);
          return (
            <Link
              key={index}
              to={`/profile/${username}`}
              className="text-primary hover:underline font-medium"
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </Link>
          );
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </span>
  );
};

export default HashtagText;
